import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ChangeLogo from "../../../assets/svg/Change password.svg";
import axios from "../../../components/Hooks/axios";
import { addAccount } from "../../../redux/slices/accountSlice";
import { logOut, setAuth, setUserObject } from "../../../redux/slices/authSlice";
import LoadingBg from "../Loading Bg/LoadingBg";
import styles from "./MobileVerification.module.scss";

const MobileVerification = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const { tempEmail } = useSelector((state) => state.temp);

	const targetEmail = tempEmail || location.state?.email || "";

	const [otp, setOtp] = useState(["","","",""]);
	const [activeOtp, setActiveOtp] = useState(0);
	const [disableBtn, setDisableBtn] = useState(false);
	const [sendOTPBtn, setSendOTPBtn] = useState(true);
	const [countDown, setCountDown] = useState(12);
	const [hasInteracted, setHasInteracted] = useState(false);
	const inputRef = useRef();

	useEffect(() => {
		if (!targetEmail) {
			navigate(location.state?.signUp ? "/signup" : "/signin", { replace: true });
		}
	}, [targetEmail, location.state?.signUp, navigate]);

	useEffect(() => {
		if (hasInteracted) {
			inputRef.current?.focus();
		}
	}, [activeOtp, hasInteracted]);

	useEffect(() => {
		setSendOTPBtn(true);
		const timer = setInterval(function () {
			if (countDown > 0) {
				setCountDown(countDown - 1);
			}
		}, 1000);
		if (countDown === 0) setSendOTPBtn(false);
		return () => clearInterval(timer);
	}, [sendOTPBtn, countDown]);

	const handelOnChange = (e, index) => {
		setHasInteracted(true);
		const value = e.target.value;
		const newOtp = [...otp];
		newOtp[index] = value.substring(value.length - 1);
		setOtp(newOtp);
		if (value) {
			setActiveOtp(index + 1);
		}
	};

	const handelOnKeyDown = (e, index) => {
		setHasInteracted(true);
		if (e.key === "Backspace") {
			if (otp[index] === "" && index > 0) {
				setActiveOtp(index - 1);
			}
		}
	};

	const handelSubmit = () => {
		if (otp[0] === "" || otp[1] === "" || otp[2] === "" || otp[3] === "") {
			inputRef.current?.focus();
			return toast.warn("Please fill !!");
		}
		setDisableBtn(true);
		axios
			.post("/auth/verify-otp", {
				email: targetEmail,
				otp: otp.join(""),
				isSignUp: Boolean(location.state?.signUp),
			})
			.then(({ data }) => {
				setDisableBtn(false);
				toast.success(data.message);
				if (data.success) {
					if (location.state?.signUp) {
						dispatch(
							setAuth({
								userId: data.data._id,
								token: data.token,
								rememberMe: location.state?.rememberMe,
							})
						);
						dispatch(setUserObject(data.data));
						dispatch(addAccount({ userId: data.data._id, user: data.data, token: data.token }));
						axios.defaults.headers.Authorization = data.token;
						navigate("/interest", { replace: true });
					} else {
						navigate("/change-password", {
							state: {
								token: data.token,
								pageLocation: location.state?.pageLocation,
								userId: location.state?.userId,
							},
						});
					}
				}
			})
			.catch(({ response }) => {
				setDisableBtn(false);
				const errorMsg = response?.data?.message || response?.data?.error || "OTP is not correct.";
				toast.error(errorMsg);
				if (location.state?.signUp) {
					// User not verified with correct OTP during Sign Up:
					// Clear credentials and redirect to Sign Up page again
					dispatch(logOut());
					navigate("/signup", { replace: true });
				}
			});
	};

	const handelSendOTP = () => {
		setSendOTPBtn(true);
		const id = toast.loading("Please wait...");
		axios
			.post("/auth/otp", {
				email: targetEmail,
			})
			.then(({ data }) => {
				setCountDown(12);
				toast.update(id, {
					render: data.message,
					type: "success",
					isLoading: false,
					autoClose: 3000,
				});
				toast.info(data.otp, {
					autoClose: 12000,
				});
				setOtp(["", "", "", ""]);
				setActiveOtp(0);
				inputRef.current?.focus();
			})
			.catch(({ response }) => {
				toast.error(response?.data?.error || response?.data?.message || "Failed to send OTP.");
			});
	};

	return (
		<div className={styles.mainContainer}>
			<LoadingBg />
			<div className={styles.form}>
				<div className={styles.header}>
					<div className={styles.textContainer}>
						<p className={styles.heading}>Verification</p>
						<p className={styles.text}>Please enter the OTP sent to your registered email id {targetEmail}</p>
					</div>
				</div>

				<div className={styles.inputContainer}>
					<div className={styles.lableContainer}>
						<label className={styles.label}>OTP</label>
                    </div>
                    
					<div className={styles.input}>
						{/* <label className={styles.label}>OTP</label> */}
						{otp.map((_, index) => (
							<input
								ref={index === activeOtp ? inputRef : null}
								key={index}
								type="number"
								className={styles.inputBox}
								value={otp[index]}
								onChange={(e) => handelOnChange(e, index)}
								onKeyDown={(e) => handelOnKeyDown(e, index)}
							/>
						))}
					</div>

					<div className={styles.submitButtonContainer}>
						<button
							className={`${styles.signInButton} ${styles.activeButton} ${styles.submitButton}`}
							onClick={handelSubmit}
							disabled={disableBtn}>
							Submit
						</button>
					</div>

					<div style={{ textAlign: "center", marginTop: "16px", cursor: "pointer" }}>
						<p
							style={{ color: "#3a0dbb", fontSize: "14px", fontWeight: "600" }}
							onClick={() => {
								if (location.state?.signUp) {
									if (targetEmail) {
										axios.post("/auth/cancel-signup", { email: targetEmail }).catch(() => {});
									}
									dispatch(logOut());
									navigate("/signup", { replace: true });
								} else {
									navigate("/signin");
								}
							}}
						>
							{location.state?.signUp ? "Back to Sign Up" : "Back to Sign In"}
						</p>
					</div>
				</div>

				<div className={styles.design}>
					<section className={styles.time}>
						<button className={styles.text2} onClick={handelSendOTP} disabled={sendOTPBtn}>
							Resend Code In:
						</button>
						<p className={styles.timer}>{countDown}s</p>
					</section>
				</div>
			</div>
		</div>
	);
};

export default MobileVerification;


